function generateList(start, end, suffix) {
	const list = []

	for (let i = start; i < end + 1; i++) {
		list.push({ id: i, text: suffix ? i + ' ' + suffix : i })
	}

	return list
}

export const selectOptions = {
	level: [
		{ id: 'beginner', text: 'Nybörjare' },
		{ id: 'intermediate', text: 'Medel' },
		{ id: 'advanced', text: 'Avancerad' },
		{ id: 'pro', text: 'Proffs' }
	],

	hight: generateList(110, 210, 'cm'),

	weight: generateList(50, 100, 'kg'),

	shoeSize: generateList(32, 44)
}
